const ExpenseType = {

    // FIELDS
    "premise": "Premise",
    "name": "Name",
    "description": "Description",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "expenseType": "Expense Type",

    // ERROR
    "error_premise": "Select Premise",
    "error_name": "Enter Name",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_premise": 'PREMISE',
    "table_name": 'NAME',
    "table_description": 'DESCRIPTION',
    "table_status": "STATUS",

}

export default ExpenseType;